import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * Shared shadcn Textarea.
 *
 * Styled to match <Input /> — same border, bg, padding, and focus ring —
 * so multi-line + single-line form fields read as one family. Chat-prompt
 * callers that want a naked textarea override with
 * ``className="rounded-none border-none …"``, and that still works because
 * these classes are merged at the end via ``cn()``.
 */
interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          'flex w-full rounded-md border border-line-default bg-surface-input px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Textarea.displayName = 'Textarea';

export { Textarea };
